var map = {
	"./mikaela.jpg": 3035,
	"./natalie-k.jpg": 8797,
	"./natalie.jpg": 7381,
	"./nicholas.jpg": 8882,
	"./old/natalie-k.jpg": 2207,
	"./susana.jpg": 8098,
	"./yashira.jpg": 4766
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9898;